import moment from 'moment';

export const formatDuration = (durationInMinutes: number) => {
  return moment().startOf('day').add(durationInMinutes, 'minutes').format('H[h] mm[m]');
};
